export const getEnvironment = (): string => {
  const hostname = window.location.hostname

  if (hostname.includes('staging.shipbae.com')) return 'Stage'
  if (hostname.includes('dev.shipbae.com')) return 'Dev'
  if (hostname.includes('gori.local') || hostname.includes('localhost')) return 'Local'

  return ''
}

export const getEnvironmentTitle = (): string => {
  const env = getEnvironment()
  return env ? `ShipBae - ${env}` : 'ShipBae'
}
